module.exports = __webpack_public_path__ + "img/mui.082ae2f5.jpg";